// OUT_OF_SIGHT_MS is how long a hidden page keeps following someone live
// before it leaves, so a forgotten tab does not keep their GPS on (002 FR-015).
export const OUT_OF_SIGHT_MS = 2 * 60_000;

// watchSight calls gone once the page has been hidden for OUT_OF_SIGHT_MS,
// and back when it shows again after that. It returns a function that stops
// watching.
export function watchSight(gone: () => void, back: () => void): () => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let away = false;
  const change = () => {
    if (document.hidden) {
      timer ??= setTimeout(() => {
        timer = null;
        away = true;
        gone();
      }, OUT_OF_SIGHT_MS);
      return;
    }
    if (timer) clearTimeout(timer);
    timer = null;
    if (away) {
      away = false;
      back();
    }
  };
  document.addEventListener('visibilitychange', change);
  // A page opened in a background tab is out of sight from the start.
  change();
  return () => {
    document.removeEventListener('visibilitychange', change);
    if (timer) clearTimeout(timer);
  };
}
